var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-main',[_vm._v(_vm._s(_vm.$t("Page visible par tout le monde")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }